import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { trpcClient } from '@/utils/trpc';
import { ToastQueue } from '@infinex/ui/components';

import { useAppKey } from './useAppKey';

export function useDappInfo() {
  const { appKey } = useAppKey();

  const dappQuery = useQuery({
    queryKey: ['dapp-info', appKey],
    queryFn: () => trpcClient.app.getDapp.query({ appKey: appKey ?? '' }),
    enabled: !!appKey,
  });

  useEffect(() => {
    if (dappQuery.error) {
      ToastQueue.add('error', {
        title: 'Something went wrong…',
        content: 'Please try again later.',
      });
    }
  }, [dappQuery.error]);

  return {
    isLoading: dappQuery.isLoading,
    dappId: dappQuery.data?.id ?? null,
    dappOrigin: dappQuery.data?.origin ?? null,
    dappIcon: dappQuery.data?.icon ?? null,
    dappKey: dappQuery.data?.appKey ?? null,
    dappUiName: dappQuery.data?.uiName ?? null,
    intents: [],
  };
}
